/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { MobileNotificationGridQueryViewModel } from "../types/MobileNotificationGridQueryViewModel.ts";
import { eMobileNotificationStatusSchema } from "./eMobileNotificationStatusSchema.ts";

export const mobileNotificationGridQueryViewModelSchema = z.object({
  pageNumber: z.optional(
    z.number().int().describe("Número da página. Mínimo 1."),
  ),
  pageSize: z.optional(
    z.number().int().describe("Quantidade de registros por página."),
  ),
  searchText: z
    .string()
    .describe(
      "Filtro textual aplicado sobre o título da notificação. Opcional.",
    )
    .nullish(),
  classStudentIds: z
    .array(z.number().int())
    .describe(
      "Filtra notificações que contenham ao menos uma das turmas informadas. Opcional.",
    )
    .nullish(),
  statusNotification: z
    .array(
      z
        .lazy(() => eMobileNotificationStatusSchema)
        .describe(
          "1 = Draft | 2 = Scheduled | 3 = Processing | 4 = Completed | 5 = Canceled | ",
        ),
    )
    .describe(
      "Filtra por um ou mais status de notificação. Opcional. Enum EMobileNotificationStatus: `1` = Draft, `2` = Scheduled, `3` = Processing, `4` = Completed, `5` = Canceled.",
    )
    .nullish(),
  createdById: z
    .number()
    .int()
    .describe("Filtra notificações criadas pelo usuário com este ID. Opcional.")
    .nullish(),
  startDate: z
    .string()
    .datetime()
    .describe(
      "Data inicial do intervalo de envio/agendamento (inclusivo). Opcional.",
    )
    .nullish(),
  endDate: z
    .string()
    .datetime()
    .describe(
      "Data final do intervalo de envio/agendamento (inclusivo). Opcional.",
    )
    .nullish(),
}) as unknown as ToZod<MobileNotificationGridQueryViewModel>;
